import Icon from '../components/Icon.vue'

Icon.register({
  grin: {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM328 176C345.7 176 360 190.3 360 208S345.7 240 328 240 296 225.7 296 208 310.3 176 328 176zM168 176C185.7 176 200 190.3 200 208S185.7 240 168 240 136 225.7 136 208 150.3 176 168 176zM248 432C187.4 432 113.5 393.7 104.2 338.7 102.2 326.9 113.5 317.1 124.9 320.8 155.1 330.5 200 336 248 336S340.9 330.5 371.1 320.8C382.4 317.1 393.7 326.9 391.8 338.7 382.5 393.7 308.6 432 248 432z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/grin.js
// module id = KH6R
// module chunks = 144